import { ComponentProps } from 'react';
import { cn } from '../platform/dom/cn';

export function Kbd({ className, ...props }: ComponentProps<'kbd'>) {
  return (
    <kbd
      className={cn(
        'flex gap-0.5 bg-fg-default/15 py-1 px-1.5 items-center rounded text-xs leading-none capitalize',
        className
      )}
      {...props}
    />
  );
}
